export const checkForEmptyNames = (passengerList: Array<any>): boolean => {
  for (let passenger of passengerList) {
    if (passenger?.first_name?.length < 2 || passenger?.last_name?.length < 2) {
      return true;
    }
  }
  return false;
};

export const checkForEmptyNamesCamelCase = (passengerList: Array<any>): boolean => {
  for (let passenger of passengerList) {
    if (passenger?.firstName?.length < 2 || passenger?.lastName?.length < 2) {
      return true;
    }
  }
  return false;
};
